import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'PART_CHANGE_ORDERS',
    itemActionName: 'PART_CHANGE_ORDER',
});
